import { render, staticRenderFns } from "./Feedback2.vue?vue&type=template&id=6c50329d&scoped=true"
import script from "./Feedback2.vue?vue&type=script&lang=js"
export * from "./Feedback2.vue?vue&type=script&lang=js"
import style0 from "./Feedback2.vue?vue&type=style&index=0&id=6c50329d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_65uhlok3ryww266g2rjqqwj3cm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c50329d",
  null
  
)

export default component.exports